<template>
  <div v-if="isLocalhost" class="d-inline-flex">
    <v-btn small rounded outlined color="secondary" @click="openDialog">
      <v-icon left small>mdi-code-json</v-icon>
      Add JSON
    </v-btn>

    <v-dialog v-model="dialog" max-width="760" persistent>
      <v-card>
        <v-card-title>Load invoice JSON</v-card-title>
        <v-card-text>
          <div class="mb-3 grey--text text--darken-1">
            Paste the complete create or edit request payload. This replaces the
            invoice currently shown in the form; it is not sent until you click
            the normal Save or Update button.
          </div>
          <v-textarea
            v-model="jsonText"
            label="Invoice JSON payload"
            placeholder="{ &quot;CustomerId&quot;: 123, &quot;InvoiceDetails&quot;: [] }"
            outlined
            autofocus
            rows="16"
            spellcheck="false"
            :error-messages="errorMessage ? [errorMessage] : []"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="applyJson">Apply JSON</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "invoice-json-importer",

  data() {
    return {
      dialog: false,
      jsonText: "",
      errorMessage: "",
    };
  },

  computed: {
    isLocalhost() {
      const hostname = window.location.hostname;
      return (
        hostname === "localhost" ||
        hostname === "127.0.0.1" ||
        hostname === "::1" ||
        hostname.endsWith(".localhost")
      );
    },
  },

  methods: {
    openDialog() {
      this.errorMessage = "";
      this.dialog = true;
    },

    applyJson() {
      try {
        const payload = JSON.parse(this.jsonText);

        if (!payload || Array.isArray(payload) || typeof payload !== "object") {
          throw new Error("The payload must be a JSON object.");
        }

        if (!Array.isArray(payload.InvoiceDetails)) {
          throw new Error("The payload must contain an InvoiceDetails array.");
        }

        this.$emit("apply", payload);
        this.dialog = false;
        this.errorMessage = "";
      } catch (error) {
        this.errorMessage = error.message || "Invalid JSON payload.";
      }
    },
  },
};
</script>
